import ScreenUtils from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelFilterContainer = styled.div`
  align-items: center;
  color: white;
  display: flex;
  flex-direction: row;
  margin-top: ${10 * ScreenUtils.widthRatio}px;
  position: relative;
  top: ${10 * ScreenUtils.widthRatio}px;
`;

export default ChannelFilterContainer;
